import React, { FC, useEffect, useRef, useState } from 'react';
import { MdExpandMore } from 'react-icons/md';
import classes from './ToggleButton.tailwind';

interface IToggleButtonProps {
  isExpanded: boolean;
  onClink?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
}

export const ToggleButton: FC<IToggleButtonProps> = ({ children, isExpanded, onClink }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isExpanded ? `${contentRef.current.scrollHeight}px` : '0px');
    }
  }, [isExpanded, children]);

  return (
    <>
      <button onClick={onClink} className={classes.buttonStyle}>
        <MdExpandMore
          style={{
            transform: `rotate(${isExpanded ? 0 : -90}deg)`,
          }}
          className="transition duration-300"
          size={25}
        />
        <p className={classes.buttonTitleStyle}>Generation configurations</p>
      </button>
      <div
        ref={contentRef}
        style={{
          height,
          overflow: 'hidden',
          transition: 'height 0.5s ease',
        }}
        className={classes.contentAnimation}
      >
        <div>{children}</div>
      </div>
    </>
  );
};
